import { Formik } from "formik";
import * as React from "react";
import { toast } from "react-toastify";
import * as yup from "yup";

import Grid from "src/library/components/Hedron";
import { Button } from "src/library/components/Button";
import {
  FormRow,
  Input,
  Label
} from "src/library/components/Forms";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import DeliveryDaysPicker from "src/core/shared/components/DeliveryDaysPicker";
import { deliveryRoutesApi } from "src/core/shared/api/deliveryRoutes.api";
import { PageProps } from "src/pages/Router/routes";
import { IDeliveryRoute } from "src/core/drops/api/drops.api";

/**
 * Create a delivery route page
 *
 */
const CreateDeliveryRoutePage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { history } = props;
  const [ createDeliveryRouteResponse, createDeliveryRoute ] = deliveryRoutesApi<IDeliveryRoute>("CREATE_DELIVERY_ROUTE");
  const [ getDeliveryRouteResponse, getDeliveryRoute ] = deliveryRoutesApi<IDeliveryRoute>("GET_DELIVERY_ROUTE");
  const [ inheritedDeliveryRoute, setInheritedDeliveryRoute ] = React.useState<IDeliveryRoute | null>(null);

  React.useEffect(() => {
    getDeliveryRoute(1);
  }, []);

  React.useEffect(() => {
    if (getDeliveryRouteResponse.data) {
      setInheritedDeliveryRoute(getDeliveryRouteResponse.data);
    }
  }, [ getDeliveryRouteResponse ]);

  React.useEffect(() => {
    if (createDeliveryRouteResponse.data) {
      history.push("/admin/delivery-routes");
    }

    if (createDeliveryRouteResponse.error) {
      toast.error("Could not create delivery route.");
    }
  }, [ createDeliveryRouteResponse ]);

  const handleSubmitSettings = (form: IDeliveryRoute) => {
    const newFormValues: Partial<IDeliveryRoute> = form;

    delete newFormValues.id;
    createDeliveryRoute(newFormValues);
  };

  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        <Grid.Bounds direction="vertical">
          <Formik
            validationSchema={yup.object().shape({ name: yup.string().required() })}
            initialValues={{
              id: 0,
              name: "",
              type: "global",
              deliveryDays: {},
              entityId: null
            }}
            onSubmit={handleSubmitSettings}
            render={({
              handleSubmit, values, setFieldValue, errors
            }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <FormRow>
                    <Input
                      error={errors.name}
                      name="name"
                      label="Name"
                      handleChange={e => setFieldValue("name", e.currentTarget.value)}
                    />
                  </FormRow>

                  <FormRow>
                    <Label
                      label="Delivery Days:"
                      for="deliveryDays"
                    />

                    {inheritedDeliveryRoute && (
                      <DeliveryDaysPicker
                        deliveryRoutes={[]}
                        value={values}
                        inherited={inheritedDeliveryRoute}
                        isGlobal
                        type="global"
                        handleChange={deliveryRoute => {
                          if (deliveryRoute) {
                            setFieldValue("deliveryDays", deliveryRoute.deliveryDays);
                          }
                        }}
                      />
                    )}
                  </FormRow>

                  <FormRow>
                    <Button type="submit">
                      Save
                    </Button>
                  </FormRow>
                </form>
              );
            }}
          />
        </Grid.Bounds>
      </MainContentWrapper>
    </Layout>
  );
};

export default CreateDeliveryRoutePage;
